import { render, staticRenderFns } from "./headerBlog.vue?vue&type=template&id=06d9107e&scoped=true&"
import script from "./headerBlog.vue?vue&type=script&lang=js&"
export * from "./headerBlog.vue?vue&type=script&lang=js&"
import style0 from "./headerBlog.vue?vue&type=style&index=0&id=06d9107e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d9107e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06d9107e')) {
      api.createRecord('06d9107e', component.options)
    } else {
      api.reload('06d9107e', component.options)
    }
    module.hot.accept("./headerBlog.vue?vue&type=template&id=06d9107e&scoped=true&", function () {
      api.rerender('06d9107e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/headers/headerBlog.vue"
export default component.exports